import { z } from "zod";

export const bookCategorySchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().optional().nullable(),
    sector: z.any().optional().nullable(),
    image: z.any().optional().nullable(),
  });
};

export type BookCategoryFormValues = z.infer<ReturnType<typeof bookCategorySchema>>;
